require('./cardPinResetView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

//@core
const { formatText } = require('core/i18n').i18n;
const { getFullName } = require('utilities/personalDataHelper');

//@commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');

//@constants
const {
    WIZARD_VERTICAL_VIEW_MODE
} = require('constants/index');
const { CARD_PIN_RESET } = require('constants/contactCenter/operationTypes');

// @ components
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const CardPinResetStep1 = require('./steps/cardPinResetStep1/cardPinResetStep1');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');

class CardPinResetView extends React.Component {
    constructor(props) {
        super(props);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleToggleCancelModal = this.handleToggleCancelModal.bind(this);
        this.handleCancelWizard = this.handleCancelWizard.bind(this);
        this.onHandleGobackCustomMessageBox = this.onHandleGobackCustomMessageBox.bind(this);
        this.state = {
            showModal: false
        };
    }

    componentWillUnmount() {
        this.props.resetWizard();
    }

    handleFinish() {
        const { match: { params: { cardId } }, handleFinish } = this.props;

        handleFinish(cardId);
    }

    handleToggleCancelModal() {
        this.setState({ showModal: !this.state.showModal });
    }

    handleCancelWizard() {
        const { history, match: { params: { cardId } } } = this.props;

        history.push(`/myprofile/cards/${cardId}/movements`);
    }

    onHandleGobackCustomMessageBox() {
        this.props.history.push('/myprofile/cards');
    }

    getBreadcrumbMap() {
        const {
            match: { params: { cardId } },
            immCards
        } = this.props;

        const immCard = immCards.getIn(['byId', cardId]);

        const breadcrumpMap = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.getIn(['alias', 'current']),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('breadcrumb-cardResetPin')
            }
        ];

        return breadcrumpMap;
    }

    buildCustomMessageBoxSuccess() {
        return (
            <CustomMessageBox
                icon="icon-success"
                title={formatText('cardPinReset-successFeedbackTitle')}
                subtitle={formatText('cardPinReset-successFeedbackSubtitle')}
                textLink={formatText('cardPinReset-titleLinkBack')}
                goBackHandler={this.onHandleGobackCustomMessageBox}
            />
        )
    }

    buildCustomMessageBoxFailure() {
        return (
            <CustomMessageBox
                icon="icon-warning"
                title={formatText('cardPinReset-failureFeedbackTitle')}
                subtitle={formatText('cardPinReset-failureFeedbackSubtitle')}
                textLink={formatText('cardPinReset-titleLinkBack')}
                goBackHandler={this.onHandleGobackCustomMessageBox}
            />
        )
    }

    buildPreleaveCancelModal() {
        return (
            <PreleaveCancelModal
                isOpen={this.state.showModal}
                onCancel={this.handleCancelWizard}
                onCloseModal={this.handleToggleCancelModal}
                onStayHere={this.handleToggleCancelModal}
            />
        );
    }

    buildWizard() {
        const {
            immProfile,
            immCards,
            immCardPinReset,
            match: { params: { cardId } },
            validateStep,
            setVisibleStep,
        } = this.props;
        const clientName = getFullName(immProfile, false);
        const cardNumber = immCards.getIn(['byId', cardId, 'number']).replace(/\s/g, '');
        const cardType = immCards.getIn(['byId', cardId, 'alias', 'current']);

        const immSteps = immCardPinReset.get('steps');

        let operationParams = { pan: cardNumber };
        const visibleStep = immCardPinReset.get('visibleStep');
        const isFetching = immCardPinReset.get('isFetching');

        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel: () => { },
            finish: this.handleFinish,
            cancel: this.handleToggleCancelModal
        }

        return (
            <Wizard
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButtonLabel="cardPinReset-nextButtonLabel"
                >
                    <CardPinResetStep1
                        clientName={clientName}
                        cardType={cardType}
                        cardNumber={cardNumber}
                    />
                </WizardStep>

                <WizardStep
                    position="last"
                    omitPreviousButton={true}
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={isFetching}
                    immFinalButton="cardPinReset-confirmButtonText"
                >
                    <VerifyOtpStep
                        operationType={CARD_PIN_RESET}
                        operationParams={operationParams}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    buildContent() {
        const { immCardPinReset } = this.props;
        const error = !!immCardPinReset.get('errorReceived');
        const hasBeenSent = immCardPinReset.get('hasBeenSent');
        const wizard = this.buildWizard();
        const preleaveCancelModal = this.buildPreleaveCancelModal();

        const messageBoxSuccess = this.buildCustomMessageBoxSuccess();
        const messageBoxFailure = this.buildCustomMessageBoxFailure();

        let content;

        if (!error && hasBeenSent) {
            content = messageBoxSuccess;
        } else if (error && !hasBeenSent) {
            content = messageBoxFailure;
        } else {
            content = (
                <div>
                    {wizard}
                    {preleaveCancelModal}
                </div>
            );
        }

        return content;
    }

    render() {
        const breadcrumpMap = this.getBreadcrumbMap();
        const content = this.buildContent();
        const title = formatText('cardPinReset-title');

        return (
            <section className="card-pin-reset">
                <OKHeaderCC
                    title={title}
                    breadcrumbConfig={breadcrumpMap}
                    showBreadBrumb={true}
                />
                <div className="card-pin-reset__body">
                    {content}
                </div>
            </section>
        );
    }
}

CardPinResetView.propTypes = {
    history: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardPinReset: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    handleFinish: PropTypes.func.isRequired,
    resetWizard: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
}

module.exports = withRouter(CardPinResetView);
